export interface Currency {
    symbol: string;
    abbreviation: string;
}

export interface Vendor {
    id: number;
    name: string;
    locale: string;
    country: string;
    currency: Currency;
    isB2B: boolean;
    isLive?: boolean;
}

// Arbitrary vendors order defined by marketing
export const VENDOR_ORDER = {
    NL: 1,
    BE: 2,
    NO: 3,
    SE: 4,
    UK: 5,
    DE: 6,
    FR: 7,
    AT: 8,
    PXXLDE: 9,
    'B2B-PXXLDE': 10,
    PBXUK: 11,
    PBXFR: 12,
    PBXIE: 13,
    PBXIT: 14,
    PBXDK: 15,
    HOFES: 16,
    HOFPT: 17,
};
